<form [formGroup]="formGroup" [bitSubmit]="submit" bit-dialog>
  <span bitDialogTitle>
    {{ "enterSshKeyPassword" | i18n }}
  </span>

  <div bitDialogContent>
    {{ "enterSshKeyPasswordDesc" | i18n }}
    <bit-form-field class="tw-mt-6">
      <bit-label>{{ "confirmSshKeyPassword" | i18n }}</bit-label>
      <input
        bitInput
        type="password"
        formControlName="sshKeyPassword"
        appAutofocus
        appInputVerbatim
      />
      <button type="button" bitSuffix bitIconButton bitPasswordInputToggle></button>
    </bit-form-field>
  </div>

  <ng-container bitDialogFooter>
    <button bitButton buttonType="primary" type="submit">
      <span>{{ "importSshKey" | i18n }}</span>
    </button>
    <button bitButton bitDialogClose buttonType="secondary" type="button">
      <span>{{ "cancel" | i18n }}</span>
    </button>
  </ng-container>
</form>
